/** имя переменной для редиректа после логина */
export const QUERY_REDIRECT_NAME = 'rc';
/** Параметр для обратной совместимости по уже созданным ранее ссылкам (кириллическая с) **/
export const DEPRECATED_QUERY_REDIRECT_NAME = 'rс';

export const QUERY_REDIRECT_REFRESH_TOKEN = 'qrrt';
export const LOCALHOST = 'localhost';
export const BASE_DOMAIN = 'centra.ai';
export const LOCAL_STORAGE_DISABLE_EXPERIMENTS = '_cen_exp_disable';

/** Кол-во попыток при 502 ошибке, считаем вместе с 0 */
export const RETRY_COUNT_502 = 2;

export const DEFAULT_CACHE_CONFIG = {
  frequentlyChanged: {
    maxAge: 60 * 1000, // 1 min
  },
  infrequentlyChanged: {
    maxAge: 60 * 60 * 1000, // 1 hour
  },
  prefix: 'centra',
};

export const DEFAULT_PAGING = {
  offset: 0,
  limit: 20,
};
